<footer class="footer pt-120">
  <div class="container">
    <div class="row">
      <div class="col-xl-3 col-lg-4 col-md-6 col-sm-10">
        <div class="footer-widget">
          <div class="logo">
            <a href="https://TechEnClutch.com">
              <img width="200" src="/assets/images/TechEnClutch Logo.png" alt="logo" loading="lazy">
            </a>
          </div>
          <!-- <p class="desc">TechEnClutch is your content backend.</p> -->
          <ul class="social-links">
            <li><a href="#0"><i class="lni lni-facebook"></i></a></li>
            <li><a href="#0"><i class="lni lni-linkedin"></i></a></li>
            <li><a href="#0"><i class="lni lni-instagram"></i></a></li>
            <li><a href="#0"><i class="lni lni-twitter"></i></a></li>
          </ul>
        </div>
      </div>
      <div class="col-xl-5 col-lg-4 col-md-12 col-sm-12 offset-xl-1">
        <div class="footer-widget">
          <h3>About Us</h3>
          <ul class="links">
            <ng-container *ngFor="let item of menuItems">
              <li><a class="page-scroll active" href="{{item.url}}">{{item.label}}</a></li>
            </ng-container>
          </ul>
        </div>
      </div>

      <div class="col-xl-3 col-lg-4 col-md-6">
        <div class="footer-widget">
          <h3>Subscribe Newsletter</h3>
          <form>
            <input type="email" placeholder="Email">
            <button class="main-btn btn-hover">Subscribe</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</footer>

<app-scroll-top></app-scroll-top>

<!-- =================== JS All Templates ========================= -->
<script src="assets/js/bootstrap.min.js"></script>
<script src="assets/js/polyfill.js"></script>
<script src="assets/js/main.js"></script>

<!-- ================= JS Index HTML only ========================= -->
<script src="assets/js/tiny-slider.js"></script>
<script src="assets/js/client-slider.js"></script>
<script src="assets/js/section-menu.js"></script>